<template>
  <div>
    <div class="col-12 d-flex justify-content-center">
      <div class="w-75">
        <form
          class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
          @keypress.enter="$event.preventDefault()"
        >
          <div
            v-if="redirectedFromCheckout"
            class="w-75 justify-content-center"
          >
            <button
              type="button"
              @click="skipAuthAndCheckout()"
              class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
            >
              {{ $t("message.continueAsGuest") }}
            </button>
            <!--       horizontal divider -->
            <div class="w-100 d-flex align-content-center mt-2">
              <div class="divider w-50 mt-3"></div>

              <span class="px-2 mt-1">{{ $t("message.or") }}</span>

              <div class="divider w-50 mt-3"></div>
            </div>
          </div>

          <h3 class="w-75 mt-3 mb-5 d-flex justify-content-center">
            {{ $t("message.verificationHeader") }}
          </h3>
          <template v-if="viewIndex == 0">
            <div class="mt-2 justify-content-center">
              <p
                v-html="$t('message.verificationHeaderDescription')"
                class="v-text"
              ></p>
            </div>

            <div class="form-group w-85 mt-4">
              <label for="telInput">{{ $t("message.phoneNumber") }}</label>
              <vue-tel-input
                name="telInput"
                id="telInput"
                :disabled="verificationPhone != null"
                v-model="phone"
                :input-options="telInputOptions"
                @input="handleTelChange"
              ></vue-tel-input>
            </div>
            <div class="mt-2 w-85 d-flex justify-content-between">
              <button
                :disabled="loading || !isPhoneValid"
                type="button"
                @click="sendSms()"
                class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
                :style="desktopStyles.btn"
              >
                {{ $t("message.sendVerificationCodeBtn") }}
                <span v-show="loading">
                  <i class="spin ml-4" />
                </span>
              </button>
            </div>
            <div class="w-75 mt-4 justify-content-center">
              <p
                v-html="
                  $t('message.termsOfUsePrivacyStatementPhoneVerification')
                "
                style="
                  font-size: 0.6875rem;
                  line-height: 1.4;
                  text-align: center;
                "
              ></p>
            </div>
          </template>
          <template v-if="viewIndex == 1">
            <h3 class="mt-3 mb-5 d-flex justify-content-center">
              {{ $t("message.mobileAlreadyRegistered") }}
            </h3>
            <div class="w-60 justify-content-center">
              <p
                v-html="$t('message.mobileAlreadyRegisteredDescription')"
                class="v-text"
              ></p>
            </div>
            <div class="mt-2 w-85 d-flex justify-content-between">
              <button
                type="button"
                @click="enterPhoneNumberAgain()"
                class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
                :style="desktopStyles.btn"
              >
                {{ $t("message.enterMobileNumberAgain") }}
              </button>
            </div>
          </template>
          <template v-if="viewIndex == 2">
            <div class="w-85 mt-2 justify-content-center">
              <p
                v-html="$t('message.verificationSentMessage')"
                class="v-text"
              ></p>
            </div>
            <!-- <div class="form-group w-85 mt-4">
              <label for="vInput">{{
                $t("message.verificationInputLabel")
              }}</label>
              <input
                v-validate="'required'"
                maxlength="9"
                id="vInput"
                v-model="smsCode"
                type="number"
                name="vInput"
                class="form-control"
                aria-describedby="emailHelp"
              />
            </div> -->
            <div class="form-group w-85 mt-4">
              <label for="vInput">{{
                $t("message.verificationInputLabel")
              }}</label>
              <verification-input
                ref="vInput"
                name="vInput"
                class="mt-2"
                @input="setSmsCode"
              />
            </div>
            <div class="mt-2 w-85 d-flex justify-content-between">
              <button
                :disabled="loading || !smsCode"
                type="button"
                @click="verifyPhoneNumber"
                class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
                :style="desktopStyles.btn"
              >
                {{ $t("message.next") }}
                <span v-show="loading">
                  <i class="spin ml-4" />
                </span>
              </button>
            </div>
            <div
              class="w-85 mt-4 d-flex align-items-center justify-content-center"
            >
              <span>{{ $t("message.smsResendDescription") }}</span>
              <button
                type="button"
                class="btn btn-link pl-1 resend-btn"
                :disabled="!enableResendBtn || loading"
                :style="desktopStyles.LinkColorTxt"
                @click="resendSms"
              >
                {{ $t("message.smsResendButton") }}
                <span v-show="!enableResendBtn && !loading"
                  >({{ resendWait }})</span
                >
              </button>
            </div>
          </template>
          <template v-if="viewIndex == 3">
            <div class="w-75 d-flex justify-content-center">
              <img
                src="https://abacus-asset.firebaseapp.com/onlineordering/images/checked.png"
                alt="success"
                style="width: 80px"
              />
            </div>
            <div class="w-60 mt-4 justify-content-center">
              <p
                v-html="$t('message.verificationSuccessfull')"
                class="text-center v-text"
              ></p>
            </div>
            <div class="mt-2 w-85 d-flex justify-content-between">
              <button
                type="button"
                @click="continueOrdering()"
                class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
                :style="desktopStyles.btn"
              >
                {{ $t("message.continueOrdering") }}!
              </button>
            </div>
          </template>
          <div v-show="error" class="w-85 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as userService from "../../api/services/userService";
import VerificationInput from "./verificationInput.vue";
export default {
  components: {
    VerificationInput,
  },
  data() {
    return {
      phone: "",
      phoneObject: null,
      loading: false,
      error: "",
      telInputOptions: {
        placeholder: "",
        required: true,
      },
      smsCode: "",
      viewIndex: 0, //0:sendsms 1:alreadyRegistered 2:enter code 3:verification sucessfull,
      resendWait: 30, //seconds
      smsTimer: null,
    };
  },
  props: {
    userModel: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    ...mapGetters([
      "desktopStyles",
      "verificationPhone",
      "showOverlay",
      "redirectedFromCheckout",
    ]),
    isPhoneValid() {
      return this.phoneObject && this.phoneObject.valid;
    },
    enableResendBtn() {
      return this.resendWait === 0;
    },
  },
  mounted() {
    if (this.verificationPhone) {
      this.phone = this.verificationPhone;
    }
    this.smsTimer = setInterval(() => {
      if (this.resendWait > 0) this.resendWait--;
    }, 1000);
  },

  beforeDestroy() {
    clearInterval(this.smsTimer);
  },
  watch: {
    verificationPhone(newValue) {
      if (newValue) {
        this.phone = this.verificationPhone;
      }
    },
    showOverlay() {
      // this.viewIndex = 0;
      // if (this.$refs.vInput) this.$refs.vInput.clear();
    },
  },
  methods: {
    ...mapActions(["setSkipAuthentication"]),
    async sendSms() {
      this.loading = true;
      this.error = "";
      try {
        let number = `0${this.phoneObject.nationalNumber}`;
        // let res = await userService.userExistsWithPhoneNumber(number);
        // if (res) {
        //   this.viewIndex = 1;
        //   this.loading = false;
        //   return;
        // }
        await userService.UpdateCustomerPhone(this.userModel, number);
        await userService.sendSmsVerification();

        this.phone = "";

        // TODO: get code and  compare with entered code

        this.viewIndex = 2;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.error = error;
      }
    },
    async resendSms() {
      this.loading = true;
      await userService.sendSmsVerification();
      this.resendWait = 30;
      this.loading = false;
    },
    async verifyPhoneNumber() {
      this.error = "";
      this.loading = true;
      let sms = await userService.getUserSms(this.userModel);
      if (this.smsCode != sms) {
        this.error = this.$t("message.smsCodeIsIncorrect");
        this.loading = false;
        return;
      }
      await userService.verifyUserPhone(this.userModel);
      this.viewIndex = 3;
      this.loading = false;
    },
    enterPhoneNumberAgain() {
      this.viewIndex = 0;
    },
    continueOrdering() {
      this.viewIndex = 0;
      this.$emit("completed");
    },
    handleTelChange(number, phone) {
      this.phoneObject = phone;
    },
    setSmsCode(value) {
      this.smsCode = value;
    },
    skipAuthAndCheckout() {
      this.setSkipAuthentication(true);
      this.$emit("completed");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text {
  font-size: 14px;
  line-height: 1.4;
}
.resend-btn {
  width: 100px;
  text-align: left;
}
</style>
